import { useRouteMatch } from 'react-router-dom';
import { links } from '../constants/links';

const useTransportPermitsMatch = () => {
  const match = useRouteMatch({
    path: [`${links.root}`, `${links.rootWithCompany}/:companyId/:page`],
    exact: true,
  });

  return match;
};

export default useTransportPermitsMatch;
